import type { NodeMock, StatePreset } from "../mock-types";
import { CHAR_POOL } from "../mock-utils";

export const characterPickMock: NodeMock = {
  label: "Character Pick",
  description: "Players pick characters in order",
  state: (players) => ({
    characterPool: [
      { id: "char_1", name: "Reaper", imageUrl: "https://picsum.photos/seed/reaper/200/267" },
      { id: "char_2", name: "Phoenix", imageUrl: "https://picsum.photos/seed/phoenix/200/267" },
      { id: "char_3", name: "Wraith", imageUrl: "https://picsum.photos/seed/wraith/200/267" },
      { id: "char_4", name: "Titan", imageUrl: "https://picsum.photos/seed/titan/200/267" },
      { id: "char_5", name: "Spectre", imageUrl: "https://picsum.photos/seed/spectre/200/267" },
      { id: "char_6", name: "Valkyrie", imageUrl: "https://picsum.photos/seed/valkyrie/200/267" },
      { id: "char_7", name: "Shadow", imageUrl: "https://picsum.photos/seed/shadow/200/267" },
      { id: "char_8", name: "Ember", imageUrl: "https://picsum.photos/seed/ember/200/267" },
      { id: "char_9", name: "Storm", imageUrl: "https://picsum.photos/seed/storm/200/267" },
      { id: "char_10", name: "Frost", imageUrl: "https://picsum.photos/seed/frost/200/267" },
      { id: "char_11", name: "Venom" },
      { id: "char_12", name: "Nova" },
    ],
    pickedCharacters: { [players[0]?.userId ?? ""]: "char_2" },
    pickOrder: players.map((p) => p.userId),
    currentPickIndex: 1,
    bannedCharacters: ["char_3"],
  }),
  config: {
    timeoutSecondsPerPick: 30,
    pickOrder: "snake",
    allowDuplicates: false,
    labels: {
      title: "Character Select",
    },
  },
};

export const characterPickPresets: StatePreset[] = [
  {
    label: "Your Turn",
    build: ({ players, viewerId, defaultState }) => {
      const pickOrder = players.map((p) => p.userId);
      const viewerIdx = Math.max(0, pickOrder.indexOf(viewerId));
      return {
        state: {
          ...defaultState,
          pickOrder,
          pickedCharacters: {},
          currentPickIndex: viewerIdx,
          bannedCharacters: ["char_3"],
        },
      };
    },
  },
  {
    label: "Waiting",
    build: ({ players, viewerId, defaultState }) => {
      const pickOrder = players.map((p) => p.userId);
      const viewerIdx = pickOrder.indexOf(viewerId);
      const otherIdx = viewerIdx === 0 ? 1 : 0;
      return {
        state: {
          ...defaultState,
          pickOrder,
          pickedCharacters: {},
          currentPickIndex: otherIdx,
          bannedCharacters: ["char_3"],
        },
      };
    },
  },
  {
    label: "Complete",
    build: ({ players, defaultState }) => {
      const pickOrder = players.map((p) => p.userId);
      const picked: Record<string, string> = {};
      const available = CHAR_POOL.filter((c) => c.id !== "char_3");
      players.forEach((p, i) => {
        picked[p.userId] = available[i % available.length]?.id;
      });
      return {
        state: {
          ...defaultState,
          pickOrder,
          pickedCharacters: picked,
          currentPickIndex: players.length,
          bannedCharacters: ["char_3"],
        },
      };
    },
  },
];
